/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { getHideViewValues } from "../../../../../store/actions/manager.action";
import { hide_view } from "../../../../../utils/helpers/objectHelpers";
import { ManagerService } from "../../../../../utils/services/manager.service";

function HideView({ dictionary, hideViewValues }) {
  const dispatch = useDispatch();

  const hideValues = hide_view.map((i) => {
    if (i.name === "hideCameraCapture") {
      i = { ...i, value: hideViewValues?.hideCameraCapture };
    }
    if (i.name === "hideCustomerBranding") {
      i = { ...i, value: hideViewValues?.hideCustomerBranding };
    }
    if (i.name === "hidePasswordRest") {
      i = { ...i, value: hideViewValues?.hidePasswordRest };
    }
    if (i.name === "hideChangePassword") {
      i = { ...i, value: hideViewValues?.hideChangePassword };
    }
    if (i.name === "hideMultiLang") {
      i = { ...i, value: hideViewValues?.hideMultiLang };
    }
    if (i.name === "disableOnlineCustomers") {
      i = { ...i, value: hideViewValues?.disableOnlineCustomers };
    }
    if (i.name === "disableOnlineCustomersLogin") {
      i = { ...i, value: hideViewValues?.disableOnlineCustomersLogin };
    }
    if (i.name === "hideCustomerCode") {
      i = { ...i, value: hideViewValues?.hideCustomerCode };
    }
    if (i.name === "switchToCashierMode") {
      i = { ...i, value: hideViewValues?.switchToCashierMode };
    }
    if (i.name === "enableChargeMakerChecker") {
      i = { ...i, value: hideViewValues?.enableChargeMakerChecker };
    }
    return { ...i };
  });

  const [open] = useState(false);
  const [hideView, setHideView] = useState(false);
  const [hideObject, setHideObject] = useState({});
  const [loading, setLoading] = useState(false);

  const onChangeInputValue = (e) => {
    setHideObject((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.checked,
    }));
  };

  const toggleHideView = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.setUpHideView(payload);
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        dispatch(getHideViewValues());
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const payload = {
    hideCameraCapture:
      hideObject?.hideCameraCapture || hideViewValues?.hideCameraCapture,
    hideCustomerBranding:
      hideObject?.hideCustomerBranding || hideViewValues?.hideCustomerBranding,
    hidePasswordRest:
      hideObject?.hidePasswordRest || hideViewValues?.hidePasswordRest,
    hideChangePassword:
      hideObject?.hideChangePassword || hideViewValues?.hideChangePassword,
    hideMultiLang: hideObject?.hideMultiLang || hideViewValues?.hideMultiLang,
    disableOnlineCustomers:
      hideObject?.disableOnlineCustomers ||
      hideViewValues?.disableOnlineCustomers,
    disableOnlineCustomersLogin:
      hideObject?.disableOnlineCustomersLogin ||
      hideViewValues?.disableOnlineCustomersLogin,
    hideCustomerCode:
      hideObject?.hideCustomerCode || hideViewValues?.hideCustomerCode,
    switchToCashierMode:
      hideObject?.switchToCashierMode || hideViewValues?.switchToCashierMode,
    enableChargeMakerChecker:
      hideObject?.enableChargeMakerChecker ||
      hideViewValues?.enableChargeMakerChecker,
  };

  return (
    <div className="card overflow-hidden">
      <div className="card-body">
        <ul className="list-group mb-2">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setHideView(!hideView)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {hideView ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary ? dictionary["WO_HIDE_VIE_-1891313213"] : "Hide view"}
          </li>
          <Collapse in={hideView}>
            <div id="example-collapse-text" className="px-3">
              <div className="form-row py-4">
                {hideValues.map((i, idx) => {
                  return (
                    <React.Fragment>
                      <div className="col-md-6 col-lg-6" key={i.id + idx}>
                        <div className="py-3">
                          <input
                            type={"checkbox"}
                            name={i.name}
                            id={i.name}
                            className="pe-3"
                            style={{ width: "18px", height: "18px" }}
                            defaultChecked={i.value}
                            onChange={(e) => onChangeInputValue(e)}
                          />
                          <span className="ps-2 align-top">{i.title}</span>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
              <div className="form-row pb-3">
                <div className="col-lg-6 col-md-6" />
                <div className="col-lg-6 col-md-6 float-end mb-3">
                  <button
                    onClick={() => toggleHideView(payload)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type="button"
                  >
                    {dictionary ? dictionary["b_update"] : "UPDATE"}
                    &nbsp;&nbsp;
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </div>
    </div>
  );
}

export default HideView;
